<template>
  <section class="container-fluid">
    <CRow class="justify-content-center">
      <CCol md="9">
        <CCard>
          <CCardHeader>
            <slot name="header">
              <div class="row">
                <div class="col-12 col-md-5">
                  <CIcon size="sm" name="cil-building" />Libreta
                  <span v-if="person.id !== null"
                    >| Estudiante :
                    <b>{{ person.last_name }} {{ person.first_name }}</b></span
                  >
                  <section>
                    <button @click="back" class="btn btn-sm btn-link">
                      Volver a la lista
                    </button>
                  </section>
                </div>
                <div class="col-12 col-md-7">
                  <div class="row">
                    <div class="col-6 col-md-3">
                      <div class="form-group">
                        <label class="control-label" for="courses_offered_year"
                          >Gestión:
                        </label>
                        <b-form-select
                          v-model="columnFilter.courses_offered_year"
                          :options="coursesOfferedYearsOptions"
                          id="courses_offered_year"
                          size="sm"
                        >
                        </b-form-select>
                      </div>
                    </div>
                    <div class="col-6 col-md-3">
                      <div class="form-group">
                        <label class="control-label" for="period"
                          >Periodo:
                        </label>
                        <b-form-select
                          v-model="columnFilter.period"
                          :options="periodOptions"
                          value-field="value"
                          text-field="name"
                          id="period"
                          size="sm"
                        >
                          <b-form-select-option :value="null">{{
                            txtPeriod
                          }}</b-form-select-option>
                        </b-form-select>
                      </div>
                    </div>
                    <div class="col-10 col-md-5">
                      <div class="form-group required">
                        <label class="control-label" for="course_offered"
                          >Curso:
                        </label>
                        <b-form-select
                          v-model="columnFilter.course_offered"
                          :options="courseOfferedOptions"
                          id="course_offered"
                          size="sm"
                          value-field="courses_offered_id"
                          text-field="course_name"
                        >
                          <b-form-select-option :value="null">{{
                            txtCourseOffered
                          }}</b-form-select-option>
                        </b-form-select>
                      </div>
                    </div>
                    <div class="col-2 col-md-1 float-right">
                      <button
                        @click="print()"
                        title="Reporte de venta"
                        class="btn btn-secondary btn-sm mt-3"
                        type="button"
                        v-if="
                          registrationData.id !== null &&
                          registrationData.sale_id !== 0 &&
                          registrationData.registration_tuition_price > 0
                        "
                      >
                        <span><CIcon size="sm" name="cil-print" /></span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </slot>
          </CCardHeader>
          <CCardBody>
            <template v-if="registrationData.id !== null">
              <template v-if="isAdmin">
                <section>
                  <div class="row mt-1">
                    <div class="col-12 col-md-5">
                      <b>Student's Name:</b>
                      {{ registrationData.student_fullname }}
                    </div>
                    <div class="col-12 col-md-7">
                      <b>Teacher's Name:</b>
                      {{ registrationData.teacher_fullname }}
                    </div>
                  </div>
                  <div class="row mt-1">
                    <div class="col-5">
                      <b>Level:</b> {{ registrationData.course_name }}
                    </div>
                    <div class="col-4">
                      <b>Term:</b>
                      {{ registrationData.course_offered_period }}/{{
                        registrationData.course_offered_year
                      }}
                    </div>
                    <div class="col-3"></div>
                  </div>
                  <div class="row mt-1">
                    <div class="col-5">
                      <b>Absences:</b> {{ registrationData.absence }}
                    </div>
                    <div class="col-4">
                      <b>Final Grade:</b> {{ registrationData.final_grade }}
                    </div>
                    <div class="col-3"><b>Minimun Required 75%</b></div>
                  </div>
                  <div class="row mt-1">
                    <div class="col-5">
                      <b>Permissions:</b> {{ registrationData.permission }}
                    </div>
                    <div class="col-7">
                      <b>Type of course:</b>
                      {{
                        registrationData.courses_offered_type_of_course
                          | type_of_course
                      }}
                    </div>
                  </div>
                </section>
                <table class="table table-bordered table-sm">
                  <thead>
                    <tr>
                      <th class="text-center" colspan="3">
                        <b>PERFORMANCE 50%</b>
                      </th>
                      <th class="text-center" colspan="2"><b>TEST 50%</b></th>
                    </tr>
                    <tr>
                      <th scope="col">Attendance 5%</th>
                      <th scope="col">Works 10%</th>
                      <th scope="col">Class Participation 35%</th>
                      <th scope="col">Quizzes 30%</th>
                      <th scope="col">Final Test 20%</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th>{{ registrationData.attendence }}</th>
                      <th>{{ registrationData.works }}</th>
                      <th>{{ registrationData.class_participation }}</th>
                      <th>{{ registrationData.quizes }}</th>
                      <th>{{ registrationData.final_test }}</th>
                    </tr>
                  </tbody>
                </table>
                <section class="mt-3">
                  <div class="row">
                    <div class="col-12">
                      <span><b>Teacher's Comments:</b></span>
                      <p>{{ registrationData.comments }}</p>
                    </div>
                  </div>
                  <div class="row mt-5 mb-3">
                    <div class="col-6 text-center">
                      <span class="border-top">Teacher's Signature</span>
                    </div>
                    <div class="col-6 text-center">
                      <b>Date:</b> {{ registrationData.execution_date }}
                    </div>
                  </div>
                </section>
              </template>
              <template v-else>
                <template
                  v-if="
                    registrationData.sale_id == 0 &&
                    registrationData.registration_tuition_price > 0
                  "
                >
                  <div class="row">
                    <div class="col-12 text-center">
                      <p>
                        La libreta no puede ser visualizada, debido a que tiene
                        una deuda pendiente de
                        <b
                          >Bs.
                          {{
                            registrationData.registration_tuition_price
                              | currency
                          }}</b
                        >
                      </p>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <section>
                    <div class="row mt-1">
                      <div class="col-12 col-md-5">
                        <b>Student's Name:</b>
                        {{ registrationData.student_fullname }}
                      </div>
                      <div class="col-12 col-md-7">
                        <b>Teacher's Name:</b>
                        {{ registrationData.teacher_fullname }}
                      </div>
                    </div>
                    <div class="row mt-1">
                      <div class="col-12 col-md-5">
                        <b>Level:</b> {{ registrationData.course_name }}
                      </div>
                      <div class="col-12 col-md-4">
                        <b>Term:</b>
                        {{ registrationData.course_offered_period }}/{{
                          registrationData.course_offered_year
                        }}
                      </div>
                      <div class="col-3"></div>
                    </div>
                    <div class="row mt-1">
                      <div class="col-6 col-md-5">
                        <b>Absences:</b> {{ registrationData.absence }}
                      </div>
                      <div class="col-6 col-md-4">
                        <b>Final Grade:</b> {{ registrationData.final_grade }}
                      </div>
                      <div class="col-12 col-md-3">
                        <b>Minimun Required 75%</b>
                      </div>
                    </div>
                    <div class="row mt-1">
                      <div class="col-5">
                        <b>Permissions:</b> {{ registrationData.permission }}
                      </div>
                      <div class="col-7">
                        <b>Type of course:</b>
                        {{
                          registrationData.courses_offered_type_of_course
                            | type_of_course
                        }}
                      </div>
                    </div>
                  </section>
                  <section class="table-responsive">
                    <table class="table table-bordered table-sm">
                      <thead>
                        <tr>
                          <th class="text-center" colspan="3">
                            <b>PERFORMANCE 50%</b>
                          </th>
                          <th class="text-center" colspan="2">
                            <b>TEST 50%</b>
                          </th>
                        </tr>
                        <tr>
                          <th scope="col">Attendance 5%</th>
                          <th scope="col">Works 10%</th>
                          <th scope="col">Class Participation 35%</th>
                          <th scope="col">Quizzes 30%</th>
                          <th scope="col">Final Test 20%</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th>{{ registrationData.attendence }}</th>
                          <th>{{ registrationData.works }}</th>
                          <th>{{ registrationData.class_participation }}</th>
                          <th>{{ registrationData.quizes }}</th>
                          <th>{{ registrationData.final_test }}</th>
                        </tr>
                      </tbody>
                    </table>
                  </section>

                  <section class="mt-3">
                    <div class="row">
                      <div class="col-12">
                        <span><b>Teacher's Comments:</b></span>
                        <p>{{ registrationData.comments }}</p>
                      </div>
                    </div>
                    <div class="row mt-5 mb-3">
                      <div class="col-6 text-center">
                        <span class="border-top">Teacher's Signature</span>
                      </div>
                      <div class="col-6 text-center">
                        <b>Date:</b> {{ registrationData.execution_date }}
                      </div>
                    </div>
                  </section>
                </template>
              </template>
            </template>
            <section class="mt-2 mb-2" v-else>
              <div class="row">
                <div
                  class="col-12 text-center"
                  v-if="registrationData.id == null"
                >
                  <p>{{ txtSearch }}</p>

                  Seleccione datos para la búsqueda.
                </div>
              </div>
            </section>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </section>
</template>
<script>
import { BFormSelect, BFormSelectOption } from "bootstrap-vue";
import TableRecords from "@/components/shared/TableRecords";
import { Utils } from "@/plugins/utils";
import Constants from "@/plugins/constants";
// Services
import Grades from "@/plugins/services/grades";
import Syllabus from "@/plugins/services/syllabus";
import Registrations from "@/plugins/services/registrations";
import People from "@/plugins/services/people";

export default {
  name: "DataReportCard",
  components: {
    TableRecords,
    BFormSelect,
    BFormSelectOption,
  },
  props: {
    student_person_id: { type: Number, required: true },
    isAdmin: { type: Boolean, required: true },
  },
  data() {
    return {
      fields: [
        {
          key: "attendence",
          label: "Attendance 5%",
          sorter: false,
          filter: false,
        },
        {
          key: "works",
          label: "Works 10%",
          sorter: false,
          filter: false,
        },
        {
          key: "class_participation",
          label: "Class participation 35%",
          sorter: false,
          filter: false,
        },
        {
          key: "quizes",
          label: "Quizzes 30%",
          sorter: false,
          filter: false,
        },
        {
          key: "final_test",
          label: "Final Test 20%",
          sorter: false,
          filter: false,
        },
      ],
      columnFilter: {
        courses_offered_year: null,
        course_offered: null,
        period: null,
      },
      coursesOfferedYearsOptions: [],
      syllabusOptions: [],
      periodOptions: Constants.periodOptions2,
      courseOfferedOptions: [],
      registrationData: {
        id: null,
        sale_id: null,
        registration_tuition_price: null,
      },
      person: {
        id: null,
      },
      loading: false,
      txtCourseOffered: "--Seleccione datos para la búsqueda--",
      txtPeriod: "--Seleccione un periodo--",
      txtSearch: "",
    };
  },
  computed: {
    userAuth() {
      return this.$store.state.userAuth;
    },
    date() {
      return this.$moment(this.userAuth.now).format("DD-MM-YYYY");
    },
  },
  mounted() {
    this.columnFilter.courses_offered_year = Utils.getYear(this.userAuth.now);
    this.columnFilter.student_person_id = this.student_person_id;
    this.getCoursesOfferedYears();
    this.getSyllabus();
    this.getPerson();
  },
  watch: {
    "columnFilter.courses_offered_year": function (courseOfferedYear) {
      this.columnFilter.course_offered = null;
      this.registrationData = {
        id: null,
        sale_id: null,
        registration_tuition_price: null,
      };
      this.getCourseOffered();
    },
    "columnFilter.period": function (courseOfferedPeriod) {
      this.columnFilter.course_offered = null;
      this.registrationData = {
        id: null,
        sale_id: null,
        registration_tuition_price: null,
      };
      this.getCourseOffered();
    },
    "columnFilter.course_offered": function (course_offered) {
      this.registrationData = {
        id: null,
        sale_id: null,
        registration_tuition_price: null,
      };
      if (course_offered) this.getOne(this.columnFilter);
    },
  },
  methods: {
    getOne(q = null) {
      this.loading = true;
      Grades.findOne(q).then((res) => {
        this.loading = false;
        if (res.data) {
          this.txtSearch = "";
          this.registrationData = res.data;
        } else this.txtSearch = "No se encontraron resultados.";
      });
    },
    getCoursesOfferedYears() {
      this.coursesOfferedYearsOptions = Utils.getYears2(this.userAuth.now);
    },
    getSyllabus() {
      Syllabus.selectAll()
        .then((res) => {
          this.syllabusOptions = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCourseOffered() {
      if (
        this.columnFilter.courses_offered_year !== null &&
        this.columnFilter.period !== null &&
        this.columnFilter.student_person_id !== null
      ) {
        Registrations.selectAllCoursesByStudent(
          this.columnFilter.courses_offered_year,
          this.columnFilter.period,
          this.columnFilter.student_person_id
        )
          .then((res) => {
            this.courseOfferedOptions = res.data;
            this.txtCourseOffered =
              this.courseOfferedOptions.length > 0
                ? "--Seleccione un curso--"
                : "--No se encontraron cursos--";
          })
          .catch((err) => {
            if (err.response && err.response.status == 404) {
              Utils.setFlash("danger", "Curso ofertado no encontrado.");
            }
            if (err.response && err.response.status == 500) {
              Utils.setFlash("danger", "Error de servidor.");
            }
          });
      }
    },
    getPerson() {
      People.getOne(this.student_person_id)
        .then((res) => {
          this.person = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    print() {
      let cFilter = this.columnFilter;
      let querystring = Utils.encodeQueryData(cFilter);
      let reportCard = `${process.env.MIX_APP_API_ENDPOINT}/grades/report-card-pdf?${querystring}`;
      Utils.printPdf(reportCard);
    },
    back() {
      this.$router.go(-1);
    },
  },
};
</script>